<script>
import FSexyScroll from "./FSexyScroll.vue";
export default {
  components: { FSexyScroll },
  props: ["variant"],
  data: function () {
    return {
      opened: false,
    };
  },
  methods: {
    toggle: function () {
      this.opened = !this.opened;
      this.$emit("update:opened", this.opened);
    },
    close: function () {
      this.opened = false;
      this.$emit("update:opened", this.opened);
    },
  },
};
</script>

<template>
  <div class="f-list" v-click-outside="close" :class="[variant]">
    <div class="f-list-title">
      <slot name="title"></slot>
    </div>
    <div class="f-list-actions">
      <slot name="actions"></slot>
    </div>
    <div class="f-list-items">
      <f-sexy-scroll>
        <slot name="items"></slot>
      </f-sexy-scroll>
    </div>
  </div>
</template>

<style lang="scss">
.f-list {
  display: flex;
  flex-wrap: wrap;

  .f-list-title {
    color: var(--white-a75);
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    align-self: center;
  }

  .f-list-actions {
    margin-left: auto;
  }

  .f-list-items {
    width: 100%;
    border: 1px solid var(--white-a25);
    border-radius: 8px;
    height: 240px;
    display: flex;
    flex-direction: column;

    .f-sexy-scroll {
      height: 0;
      flex: 1 1 auto;
    }
  }
}
</style>